import React from 'react';

// Themed button primitive. variant: 'primary' | 'ghost' | 'danger'.
// size: 'sm' | undefined. All other props (onClick, type, disabled, aria-*)
// pass through.
const VARIANT_CLASS = {
  ghost: 'ss-btn--ghost',
  danger: 'ss-btn--danger',
  primary: 'ss-btn--primary',
};

export default function Button({
  variant = 'primary',
  size,
  type = 'button',
  className = '',
  children,
  ...rest
}) {
  const cls = [
    'ss-btn',
    VARIANT_CLASS[variant] || VARIANT_CLASS.primary,
    size === 'sm' ? 'ss-btn--sm' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={cls} {...rest}>
      {children}
    </button>
  );
}
